/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.25",
    versionName: "0.2.0-nightly.2026.4.25",
    versionChannel: "nightly",
    buildDate: "2026-04-25T00:17:13.634Z",
    commitHash: "02e036ffd6dfe225b47e17b944b2c4e53da4132a",
};
